import { createQuery } from 'react-query-kit';
import { queryOrgId } from '@/rqs';

export const useOrgId = createQuery<string, void, Error>({
  primaryKey: 'orgid',
  queryFn: queryOrgId,
});
